
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11V13ZM3 22L2.04119 21.716C1.95157 22.0185 2.00997 22.3455 2.19874 22.5983C2.38751 22.8511 2.6845 23 3 23V22ZM21 22V23C21.3155 23 21.6125 22.8511 21.8013 22.5983C21.99 22.3455 22.0484 22.0185 21.9588 21.716L21 22ZM13.9993 3.53452C14.4773 3.81106 15.0891 3.6477 15.3656 3.16964C15.6421 2.69158 15.4788 2.07985 15.0007 1.80331L13.9993 3.53452ZM12 11C9.79086 11 8 9.20914 8 7H6C6 10.3137 8.68629 13 12 13V11ZM8 7C8 4.79086 9.79086 3 12 3V1C8.68629 1 6 3.68629 6 7H8ZM3.95881 22.284C5.04818 18.6067 8.26481 16 12 16V14C7.28876 14 3.35554 17.2791 2.04119 21.716L3.95881 22.284ZM12 16C15.7352 16 18.9518 18.6067 20.0412 22.284L21.9588 21.716C20.6445 17.2791 16.7112 14 12 14V16ZM3 23H21V21H3V23ZM12 3C12.7302 3 13.4119 3.19477 13.9993 3.53452L15.0007 1.80331C14.1172 1.29221 13.0912 1 12 1V3Z","fill":"#262D33"}}),_c('path',{attrs:{"d":"M15 12L23 4M23 4H17M23 4V10","stroke":"#262D33","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    